<template>
  <div class="esp_home" :class="{ 'menu-expanded': !isMenuCollapsed }">>
    <div class="esp_left_top">
      <img
        :src="this.isMenuCollapsed
                      ? require('@/assets/home/banner1920.jpg')
                      : require('@/assets/home/banner1620.jpg')"
        class="banner-image"/>
    </div>

    <div class="esp_left_bottom">
      <div class="menu-section">
        <div class="remote-play-container" :class="{ 'active-menu': activeMenu === '/videoPlay' }"
             @click="handleMenuClick('/videoPlay')">
          <div class="icon">
            <img :src="require('@/assets/home/Video-Playeb.png')"
                 style="width: 20px; margin-right: 5px; vertical-align: middle;">
          </div>
          <div class="text">{{this.$t("menu_video_funscripts_player")}}</div>
        </div>
        <div class="remote-play-container" :class="{ 'active-menu': activeMenu === '/motions' }"
             @click="handleMenuClick('/motions')">
          <div class="icon">
            <img :src="require('@/assets/home/Custom-Motionsb.png')"
                 style="width: 20px; margin-right: 5px; vertical-align: middle;">
          </div>
          <div class="text">{{this.$t("menu_custom_motions")}}</div>
        </div>
        <div class="remote-play-container" :class="{ 'active-menu': activeMenu === '/remote' }"
          @click="handleMenuClick('/remote')">
          <div class="icon">
            <img :src="require('@/assets/home/Remote-Playb.png')"
                 style="width: 20px; margin-right: 5px; vertical-align: middle;">
          </div>
          <div class="text">{{this.$t("menu_remote_play")}}</div>
        </div>
      </div>

      <div class="menu-section">
        <div class="remote-play-container" :class="{ 'active-menu': activeMenu === '/softwares' }"
             @click="handleMenuClick('/softwares')">
          <div class="icon">
            <img :src="require('@/assets/home/Softwaresb.png')"
                 style="width: 20px; margin-right: 5px; vertical-align: middle;">
          </div>
          <div class="text">{{this.$t("menu_softwares")}}</div>
        </div>

        <div class="remote-play-container" :class="{ 'active-menu': activeMenu === '/guide' }"
          @click="handleMenuClickForGuide('/guide')">
          <div class="icon">
            <img :src="require('@/assets/home/User-Guideb.png')"
                 style="width: 20px; margin-right: 5px; vertical-align: middle;">
          </div>
          <div class="text">{{this.$t("menu_user_guide")}}</div>
        </div>

        <div class="remote-play-container" :class="{ 'active-menu': activeMenu === '/resource' }"
             @click="handleMenuClickForResource('/resource')">
          <div class="icon">
            <img :src="require('@/assets/home/resource.png')"
                 style="width: 20px; margin-right: 5px; vertical-align: middle;">
          </div>
          <div class="text">{{this.$t("menu_resource")}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EspHome",
  props: {
    isMenuCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toDoData: [],       // 待办
      tableData: {
        totalRow: 0,
        data: []
      },
      isMenuCollapsed: true, // 添加菜单状态跟踪
      activeMenu: '' // 跟踪当前激活的菜单
    }
  },
  computed: {
    bannerImage() {
      return this.isMenuCollapsed
        ? require("@/assets/home/banner1920.jpg")
        : require("@/assets/home/banner1620.jpg");
    }
  },
  methods: {
    // 添加切换菜单状态的方法
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    handleMenuClick(path) {
      this.activeMenu = path;
      // 路径不同才跳，避免重复跳转的问题
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    handleMenuClickForResource(path) {
      // this.activeMenu = path;
      window.open('https://miraplay.fun/firmware/index.html', '_blank');
      return;
    },
    handleMenuClickForGuide(path) {
      this.activeMenu = path;
      window.open('https://mirabotx.co.jp/user-guide/', '_blank');
      return;
    },
    handleMenuClickForProducts(path) {
      this.activeMenu = path;
      window.open('https://mirabotx.co.jp', '_blank');
      return;
    },
  },
  created() {
    // 初始化时设置当前激活菜单
    this.activeMenu = this.$route.path;
  },
  watch: {
    // 监听路由变化，更新激活菜单
    '$route'(to) {
      this.activeMenu = to.path;
    }
  }
}
</script>

<style lang="less">
.esp_home {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  background-color: #eff3f1;

  & > div {
    position: absolute;
    background-color: #ffffff;
    overflow: hidden;
  }

  .esp_left_top {
    width: 100%;
    height: 40vh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;

    .banner-image {
      display: flex;
      width: 100%;
      height: 100%;
      object-fit: cover;
      min-width: 100%;
      min-height: 100%;
    }
  }

  .esp_left_bottom {
    top: calc(40vh);
    bottom: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start; /* 修改为从顶部开始 */
    padding-top: 20px; /* 添加一些顶部内边距 */
  }

  .menu-section {
    display: flex;
    width: auto; /* 改为自动宽度 */
    flex-wrap: wrap;
    justify-content: center; /* 改为居中 */
    row-gap: 20px;
    column-gap: 20px;
    margin-top: 25px; /* 移除顶部外边距 */
  }

  /* 其他样式保持不变 */
  .remote-play-container2 {
    width: 190px;
    height: 130px;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    opacity: 0.8;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .remote-play-container {
    width: 190px;
    height: 130px;
    background-color: #240044;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    opacity: 0.8;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      opacity: 1;
      transform: translateY(-3px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    &.active-menu {
      opacity: 1;
      background-color: #3a0068;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

      .text {
        color: #ffffff;
        font-weight: bold;
      }
    }
  }

  .icon {
    display: flex;
    margin-bottom: 10px;
  }

  .text {
    color: #d0d0d0;
    font-size: 14px;
    font-family: PingFang SC;
    transition: all 0.3s ease;
  }

  .esp_right {
    top: 10px;
    right: 10px;
    bottom: 10px;
    width: 30%;

    .esp_user_img {
      text-align: center;
      margin-top: 20%;

      img {
        width: 100px;
      }
    }

    .esp_user_info {
      margin-top: 50px;
    }

    .esp_user_more {
      position: absolute;
      right: 10px;
      bottom: 0px;
    }
  }

  .esp_home_msg {
    height: 30px;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    color: #222222;
    font-size: 14px;
    padding: 0px 10px;
    border-radius: 4px;

    &:hover {
      cursor: pointer;
      background-color: rgba(187, 187, 187, 0.1);
    }

    & > div:nth-child(1) {
      width: 20px;

      i {
        color: #00CF83;
        font-size: 12px;
      }
    }

    & > div:nth-child(2) {
      flex: 1;
    }

    & > div:nth-child(3) {
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/home.vue